export enum VFDType {
    Power = "Power",
    Flow = "Flow",
    Head = "Head",
}